<div class="uk-flex uk-flex-row">
  <div>
    <p>Formation:</p>
    <p>Modalité:</p>
    <p>Durée:</p>
    <p>Lieu Principal:</p>
    <p>Organisation:</p>
  </div>
  <div class="uk-margin-large-left">
    <p>{{ formationInfo.p_libelle || '' }}</p>
    <p>{{ formationInfo.m_libelle || '' }}</p>
    <p>
      {{ formationInfo?.duree }} jours, du {{ formationInfo?.j_premier | date: 'dd/MM/yyyy' }} au
      {{ formationInfo?.j_dernier | date: 'dd/MM/yyyy' }}
    </p>
    <p>
      {{ formationInfo?.adresse_site }}<br />{{ formationInfo?.ville_site }}<br />
      {{ formationInfo?.cp_site }}
    </p>
    <p>{{ formationInfo?.organisation }}</p>
  </div>
</div>
<div class="uk-card uk-card-default uk-width-1-1@xl border-radius-5">
  <h3 class="uk-card-title uk-background-muted k-text-uppercase uk-padding-small k-card-title">
    RESPONSABLE ADMINISTRATIF
  </h3>
  <div class="uk-flex uk-flex-row">
    <div
      class="uk-margin-small-top uk-margin-small-bottom uk-margin-medium-left uk-margin-medium-right circular--portrait"
    >
      <img
        [src]="formationInfo.photo ? formationInfo.photo : 'https://via.placeholder.com/150'"
        alt="placeholder.com"
      />
    </div>
    <div class="uk-flex uk-flex-column">
      <p class="uk-margin-remove">
        Lorem ipsum GMAIL
      </p>
      <p class="uk-margin-remove">
        Tel: 23423423423
      </p>
      <p class="uk-margin-remove">
        zczczxczxczcx&#64;asda.com
      </p>
    </div>
  </div>
</div>
<div class="uk-card uk-card-default uk-width-1-1@xls uk-margin-small-top">
  <h3 class="uk-card-title uk-background-muted k-text-uppercase uk-padding-small k-card-title">
    COMMANDITAIRE(s)
  </h3>
  <!--<kendo-grid [data]="commanditaireInfo | async">-->
  <!--<kendo-grid-column field="commanditaire" title="COMMANDITAIRE" width="100"> </kendo-grid-column>-->
  <!--<kendo-grid-column field="apprenant" title="APPRENANT(S)" width="100"> </kendo-grid-column>-->
  <!--</kendo-grid>-->
</div>
